module.exports = __webpack_public_path__ + "img/[庆祝].bc16f1cc.svg";